import React, { useState ,useEffect} from "react";
import { diffWords } from "diff";
import "./DiffModal.css";
const DiffModal = ({
	show,
	onCancel,
	oldValue,
	newValue,
	onConfirm,
	title = "Compare Prompts",
	confirmLabel = "Use Improved Prompt",
	cancelLabel = "Cancel",
	secondaryLabel,
	onSecondary,
	/** Bootstrap dialog size class suffix; default xl matches Botbuilder improve-goal flow. */
	modalSize = "xl",
	/** Dialog max-width; default 95vw matches Botbuilder improve-goal flow. */
	modalWidth = "95vw",
	/** Optional style merged onto the "Current Prompt" header row (report-call opt-in). */
	currentHeaderStyle,
}) => {
const [isEditing, setIsEditing] = useState(false);
const [showEditedDiff, setShowEditedDiff] = useState(false);
const [currentImprovedPrompt, setCurrentImprovedPrompt] = useState(newValue || '');
const [editedPrompt, setEditedPrompt] = useState(currentImprovedPrompt || '');

useEffect(() => {
	setCurrentImprovedPrompt(newValue || '');
	setEditedPrompt(newValue || '');
	setIsEditing(false);
	setShowEditedDiff(false);
}, [newValue, show]);

if (!show) return null;
const diffText = diffWords(oldValue || '', currentImprovedPrompt || '');
	const renderDiff = (diffArray, type) => {
		return diffArray.map((part, index) => {
			if (type === "old") {
				if (part.removed) {
					return (
						<span key={index} className="deleted">
							{part.value}
						</span>
					);
				} else if (!part.added && !part.removed) {
					return <span key={index}>{part.value}</span>;
				}
			}
			if (type === "new") {
				if (part.added) {
					return (
						<span key={index} className="added">
							{part.value}
						</span>
					);
				} else if (!part.added && !part.removed) {
					return <span key={index}>{part.value}</span>;
				}
			}
			return null;
		});
	};

	return (
		<div
			className="modal show d-block"
			tabIndex="-1"
			role="dialog"
			style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9999 }}
		>
			<div
				className={`modal-dialog modal-${modalSize}`}
				role="document"
				style={{
					maxWidth: modalWidth,
					width: "100%",
					margin: "1rem auto",
					maxHeight: "90vh",
					overflowY: "auto",
					scrollBehavior: "smooth",
				}}
			>
				<div className="modal-content">
					<button
						type="button"
						className="close linear-gradient"
						aria-label="Close"
						onClick={onCancel}
						style={{ position: "absolute", top: "10px", right: "15px", zIndex: 1000 }}
					>
						X
					</button>

					<div className="modal-header">
						<h5 className="modal-title">{title}</h5>
					</div>

					<div className="modal-body">
						<div className="row">
							<div className="col-md-6">
								<div
									className="d-flex justify-content-between align-items-center"
									style={currentHeaderStyle}
								>
									<h6>Current Prompt</h6>

								</div>
								<div className="diff-box">{renderDiff(diffText, "old")}</div>
							</div>
							<div className="col-md-6">
								<div className="d-flex justify-content-between align-items-center">
									<h6>Improved Prompt</h6>
									<button
										className="btn linear-gradient yr-submitbtn btn-sm mb-2"
										onClick={() => {
											if (isEditing) {
												// Save changes
												setCurrentImprovedPrompt(editedPrompt);
												setShowEditedDiff(true);
											}
											setIsEditing(!isEditing);
										}}
									>
										{isEditing ? "Save" : "Edit"}
									</button>
								</div>
								{isEditing ? (
									<textarea
										value={editedPrompt}
										onChange={(e) => setEditedPrompt(e.target.value)}
										style={{
											width: "100%",
											height: "200px",
											padding: "10px",
											fontFamily: "monospace",
											fontSize: "14px",
										}}
									/>
								) : (
									<div className="diff-box">
										{renderDiff(diffWords(oldValue || '', currentImprovedPrompt || ''), "new")}
									</div>
								)}
							</div>
						</div>
					</div>

					<div className="modal-footer">
						<button
							type="button"
							onClick={onCancel}
							className="yr-cancelbtn linear-gradient-cancel btn-sm yr-btn-small"
						>
							<span>{cancelLabel}</span>
						</button>
						{secondaryLabel && typeof onSecondary === "function" && (
							<button
								type="button"
								onClick={() => onSecondary(currentImprovedPrompt)}
								className="yr-cancelbtn linear-gradient-cancel btn-sm yr-btn-small"
							>
								<span>{secondaryLabel}</span>
							</button>
						)}
						<button
							type="button"
							onClick={() => onConfirm(currentImprovedPrompt )}
							className="btn linear-gradient yr-submitbtn btn-sm"
						>
							<span>{confirmLabel}</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default DiffModal;
